<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button status="primary" v-if="isHavePermission('eleWaybill:report')" @click="report">上报</Button>
      <Button status="primary" v-if="isHavePermission('eleWaybill:giveupLogistics')" @click="giveupLogistics"
              :style="isHavePermission('eleWaybill:report')? 'margin-left: 10px' : ''">弃报
      </Button>
    </div>
    <div class="search-box" style="margin-bottom: 10px;">
      <vxe-input v-model="ydNumber" type="search" placeholder="电子运单号" @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <vxe-input v-model="carrier" type="search" style="margin-left: 10px" placeholder="网络货运经营者" @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <vxe-input v-model="originalDocumentNumber" style="margin-left: 10px" type="search" placeholder="原始单号"
                 @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <vxe-input v-model="shippingNoteNumber" style="margin-left: 10px" type="search" placeholder="运单号"
                 @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <vxe-input v-model="consignor" style="margin-left: 10px" type="search" placeholder="托运人名称" @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <vxe-input v-model="vehicleNumber" style="margin-left: 10px" type="search" placeholder="车牌号"
                 @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <vxe-select v-model="searchFormData.reportTime" style="margin-left: 10px" :options="timeOptions"
                  placeholder="上报时间"
      ></vxe-select>
      <vxe-input v-model="reportUser" style="margin-left: 10px" type="search" placeholder="操作人" @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <div class="search-filter">
        <vxe-modal
            class="timeModal"
            v-model="open"
            width="460"
            height="400"
            :show-footer="false"
            :showHeader="false"
        >
          <template v-slot>
            <DatePicker
                :open="open"
                confirm
                type="daterange"
                :split-panels="true"
                placeholder
                style="width: 432px"
                @on-change="handleChange"
                @on-clear="handleClear"
                @on-ok="handleOk"
            >
              <span class="date-slot"></span>
            </DatePicker>
          </template>
        </vxe-modal>
      </div>
      <Button type="primary" icon="ios-search" @click="search" style="margin-left: 10px;border-radius: 5px">
        搜索
      </Button>
      <vxe-button icon="vxe-icon--refresh" @click="reset" style="margin-left: 10px">重置</vxe-button>
      <vxe-button icon="vxe-icon--refresh" @click="refresh" style="margin-left: 10px">刷新</vxe-button>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          stripe
          highlight-hover-row
          show-footer
          show-overflow
          ref="xGrid"
          max-height="560"
          border="none"
          align="center"
          :loading="loading"
          :data="infoListData"
          @filter-change="filterChangeMethod"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
          @sort-change="sortChangeEvent"
      >
        <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
        <vxe-table-column field="acthion" title="操作" width="80">
          <template slot-scope="{ row }">
            <a v-if="row.reportStatus !== 1 && isHavePermission('eleWaybill:edit')" @click="goUpdate(row.id)">编辑</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="id" width="60" align="center" title="序号"></vxe-table-column>
        <vxe-table-column field="ydNumber" title="电子运单号" width="120">
          <template slot-scope="{ row }">
            <span @click="showDetail(row.id)" style="color: #2d8cf0; cursor: pointer">{{ row.ydNumber }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="reportStatus" title="上报" width="100"
                          :filters="[{label: '未上报', value: 0}, {label: '成功', value: 1},{label: '失败', value: 2}]"
                          :filter-multiple="false">
          <template slot-scope="{ row }">
            <span style="color: #F59A23">{{row.reportStatus | reportStatusMap}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="carrier" title="网络货运经营者" width="120">
        </vxe-table-column>
        <vxe-table-column field="originalDocumentNumber" title="原始单号" width="120">
        </vxe-table-column>
        <vxe-table-column field="shippingNoteNumber" title="运单号" width="120">
        </vxe-table-column>
        <vxe-table-column field="consignor" title="托运人名称" width="120">
        </vxe-table-column>
        <vxe-table-column field="actualCarrierName" title="实际承运人名称" width="120">
        </vxe-table-column>
        <vxe-table-column field="vehicleNumber" title="车牌号" width="120">
        </vxe-table-column>
        <vxe-table-column field="actualCarrierBusinessLicense" title="道路运输经营许可证" width="150">
        </vxe-table-column>
        <vxe-table-column field="deadweight" title="核定载质量(吨)" width="120">
        </vxe-table-column>
        <vxe-table-column field="driverName" title="驾驶人姓名" width="100">
        </vxe-table-column>
        <vxe-table-column field="drivingLicense" title="驾驶人身份证号码" width="180">
        </vxe-table-column>
        <vxe-table-column field="descriptionOfGoods" title="货名" width="80">
        </vxe-table-column>
        <vxe-table-column field="goodsItemGrossWeight" title="货物项毛重(kg)" width="120">
        </vxe-table-column>
        <vxe-table-column field="despatchActualDateTime" title="发货时间" width="150">
          <template slot-scope="{ row }">
            <span>{{ row.despatchActualDateTime }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsReceiptDateTime" title="收货时间" width="150">
          <template slot-scope="{ row }">
            <span>{{ row.goodsReceiptDateTime }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="placeOfLoading" title="装货地" width="150">
        </vxe-table-column>
        <vxe-table-column field="goodsReceiptPlace" title="收货地" width="150">
        </vxe-table-column>
        <vxe-table-column field="reportTime" title="上报时间" width="150" remote-sort>
          <template slot-scope="{ row }">
            <span>{{ row.reportTime | timeFormat }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="reportUser" title="操作人" width="80">
        </vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate}}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="pageChange"
      ></vxe-pager>
    </div>
    <vxe-modal v-model="isShowDetailModal" :title="modalTitle" width="1400" height="800" resize>
      <eleWaybillDetail ref="eleWaybill" @afterSave="afterSave"
                        :cityData="cityData" :business_type_code="business_type_code"
                        :insurance_company_code="insurance_company_code"
                        :transport_type_code="transport_type_code"
                        :goods_type_code="goods_type_code"
                        :vehicle_plate_color_code="vehicle_plate_color_code"></eleWaybillDetail>
    </vxe-modal>
    <vxe-modal v-model="reportVisible" title="数据上报" width="500" height="300" resize position="center"
               destroy-on-close>
      <choose-report ref="reportModal" @close="closeReport" @report="reportLogistics"></choose-report>
    </vxe-modal>
    <vxe-modal v-model="messageVisible" title="消息提示" width="600" height="350" @close="closeMessage" position="center">
      <Message ref="messageModal" @close="closeMessage"></Message>
    </vxe-modal>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import {isEmpty} from "@/utils/util";
  import {showLoading, hideLoading} from "@/utils/util";
  import eleWaybillDetail from "@/views/report/eleWaybillDetail";
  import ChooseReport from "@/components/modal/ChooseReport";
  import {SEARCH_TIME} from "@/filters/time";
  import moment from "moment";
  import Message from "@/components/common/Message";
  import getAuthOrization from "@/mixin/getAuthOrization";

  export default {
    components: {eleWaybillDetail, ChooseReport, Message},
    mixins: [getAuthOrization],
    data() {
      return {
        loading: false,
        infoListData: [],
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 0,
        },
        isShowDetailModal: false,
        modalTitle: "运单详情",
        formData: {},
        tableData: [],
        records: [],
        cityData: [],
        business_type_code: [],
        insurance_company_code: [],
        transport_type_code: [],
        goods_type_code: [],
        vehicle_plate_color_code: [],
        reportVisible: false,
        messageVisible: false,
        searchFormData: {
          reportTime: null
        },
        timeOptions: SEARCH_TIME.options,
        carrier: null,
        originalDocumentNumber: null,
        shippingNoteNumber: null,
        consignor: null,
        vehicleNumber: null,
        reportUser: null,
        ydNumber: null,
        reportStatus: null,
        isDesc: null
      };
    },
    watch: {
      "searchFormData.reportTime": {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          this.openRangeDate("reportTime");
        },
      },
    },
    mounted() {
      this.$bus.$on("电子运单", () => {
        this.reset();
        this.getInfoList();
        this.getCityDate();
        this.getKeyByCode(500, 'transport_type_code');
        this.getKeyByCode(501, 'business_type_code');
        this.getKeyByCode(502, 'insurance_company_code');
        this.getKeyByCode(41100, 'goods_type_code');
        this.getKeyByCode(40300, 'vehicle_plate_color_code');
      })
      this.getInfoList();
      this.getCityDate();
      this.getKeyByCode(500, 'transport_type_code');
      this.getKeyByCode(501, 'business_type_code');
      this.getKeyByCode(502, 'insurance_company_code');
      this.getKeyByCode(41100, 'goods_type_code');
      this.getKeyByCode(40300, 'vehicle_plate_color_code');
    },
    methods: {
      sortChangeEvent(sort) {
        if (sort.order == null) {
          this.isDesc = null
        } else {
          this.isDesc = sort.order === 'desc' ? 1 : 0
        }
        this.getInfoList();
      },
      filterChangeMethod({column, property, values, datas, filters, $event}) {
        this.page.currentPage = 1;
        if (property === "reportStatus") {
          if (values.length > 0) {
            this.reportStatus = values[0];
          } else {
            this.reportStatus = null;
          }
        }
        this.getInfoList();
      },
      reset() {
        this.searchFormData = {
          reportTime: null
        };
        this.ydNumber = null;
        this.carrier = null;
        this.originalDocumentNumber = null;
        this.shippingNoteNumber = null;
        this.consignor = null;
        this.vehicleNumber = null;
        this.reportUser = null;
        this.reportStatus = null;
      },
      search() {
        this.page.currentPage = 1
        this.getInfoList();
      },
      openRangeDate(field) {
        if (this.searchFormData[field] === 1) {
          this.rangeTime = field;
          this.open = true;
        } else {
          this.open = false;
        }
      },
      handleChange(date) {
        this.timeVal = date;
        // this.timeVal = date.map( v => moment(v).valueOf());
        console.log(this.timeVal);
      },
      handleClear() {
      },
      handleOk() {
        this.searchFormData[this.rangeTime] = this.timeVal;
        this.rangeTime = false;
        let that = this;
        setTimeout(() => {
          that.searchVisible = true;
        }, 100);
      },
      report() {
        let records = this.records;
        if (records.length === 0) {
          this.$XModal.alert({
            message: '请选择至少一条数据',
            status: "error",
          });
          return
        }
        this.reportVisible = true;
        this.$nextTick(() => {
          this.$refs.reportModal.queryConfigList();
        });
      },
      closeReport() {
        this.reportVisible = false;
      },
      async giveupLogistics() {
        let records = this.records;
        if (records.length === 0) {
          this.$XModal.alert({
            message: '请选择至少一条数据',
            status: "error",
          });
          return
        }
        let idList = [];
        records.map(i => {
          idList.push(i.id);
        })
        showLoading();
        let res = await $api.reportData.request('giveupLogistics', {
          ids: idList,
        });
        hideLoading();
        if (res.status === 1) {
          this.$Message.success('弃报成功');
          this.records = [];
          this.page.currentPage = 1;
          this.getInfoList();
        } else {
          let data = res.data;
          let message = '';
          if (data.length > 0) {
            data.map(i => {
              message = message + i.failMsg + '\n';
            })
          }
          if (message === '') {
            this.$XModal.alert({
              message: "接口异常",
              status: "error",
            });
          } else {
            this.$refs.messageModal.setMessage(message);
            this.messageVisible = true;
          }
        }
      },
      async reportLogistics(reportCompany) {
        let records = this.records;
        let idList = [];
        records.map(i => {
          idList.push(i.id);
        })
        showLoading();
        let res = await $api.reportData.request('reportLogistics', {
          ids: idList,
          reportCompany: reportCompany
        });
        hideLoading();
        if (res.status === 1) {
          this.$Message.success('上报成功');
          this.reportVisible = false;
          this.records = [];
          this.getInfoList();
        } else {
          let data = res.data;
          let message = '';
          if (data.length > 0) {
            data.map(i => {
              message = message + i.failMsg + '\n';
            })
          }
          if (message === '') {
            this.$XModal.alert({
              message: "接口异常",
              status: "error",
            });
          } else {
            this.$refs.messageModal.setMessage(message);
            this.messageVisible = true;
          }
        }
      },
      closeMessage() {
        this.messageVisible = false;
      },
      afterSave() {
        this.isShowDetailModal = false;
        this.getInfoList();
      },
      selectChangeEvent({checked, row}) {
        if (checked) {
          this.records.push(row);
        } else {
          let key = this.records.indexOf(row);
          this.records.splice(key, 1);
        }
      },
      selectAllEvent({checked, records}) {
        if (checked) {
          this.records = records;
        } else {
          this.records = [];
        }
      },
      async getInfoList() {
        let reportTime = this.searchFormData.reportTime;
        let reportTimeBegin = null;
        let reportTimeEnd = null;
        if (reportTime && reportTime.length > 0) {
          reportTimeBegin = moment(reportTime[0]).valueOf(); // 开始时间
          reportTimeEnd = moment(reportTime[1]).valueOf() + 86399999; // 结束时间
        }
        this.loading = true;
        let res = await $api.reportData.post('queryLogisticsList', {
          ydNumber: this.ydNumber,
          carrier: this.carrier,
          originalDocumentNumber: this.originalDocumentNumber,
          shippingNoteNumber: this.shippingNoteNumber,
          consignor: this.consignor,
          vehicleNumber: this.vehicleNumber,
          reportUser: this.reportUser,
          reportTimeBegin: reportTimeBegin,
          reportTimeEnd: reportTimeEnd,
          reportStatus: this.reportStatus,
          isDesc: this.isDesc,
          orderBy: 2,
          page: this.page.currentPage,
          rows: this.page.pageSize,
        });

        //   if (!isEmpty(this.searchName)) {
        //     params.name = this.searchName;
        //   }

        this.loading = false;
        if (res.status === 1) {
          this.infoListData = res.data.rows;
          this.page.totalResult = res.data.total;
          this.infoListData.map((i) => {
            if (i.placeOfLoading) {
              i.placeOfLoading = i.placeOfLoading.replace(/,/g, '');
            }
            if (i.placeOfLoadingDetail) {
              i.placeOfLoading = i.placeOfLoading + i.placeOfLoadingDetail;
            }
            if (i.goodsReceiptPlace) {
              i.goodsReceiptPlace = i.goodsReceiptPlace.replace(/,/g, '');
            }
            if (i.goodsReceiptPlaceDetail) {
              i.goodsReceiptPlace = i.goodsReceiptPlace + i.goodsReceiptPlaceDetail;
            }
            if (i.despatchActualDateTime) {
              let despatchActualDateTime = this.strDate(i.despatchActualDateTime);
              i.despatchActualDateTime = this.$utils.toDateString(new Date(despatchActualDateTime), "yyyy-MM-dd HH:mm:ss");
            }
            if (i.goodsReceiptDateTime) {
              let goodsReceiptDateTime = this.strDate(i.goodsReceiptDateTime);
              i.goodsReceiptDateTime = this.$utils.toDateString(new Date(goodsReceiptDateTime), "yyyy-MM-dd HH:mm:ss");
            }
            this.records.map((j) => {
              if (i.id === j.id) {
                this.$refs.xGrid.setCheckboxRow(i, true);
              }
            });
          });
        } else {
          this.$XModal.alert({
            message: "接口异常",
            status: "error",
          });
        }
      },
      strDate(dateString) {
        const pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
        return new Date(dateString.replace(pattern, '$1/$2/$3 $4:$5:$6'));
      },
      refresh() {
        // 刷新
        this.getInfoList();
      },
      pageChange(e) {
        this.page.currentPage = e.currentPage;
        this.page.pageSize = e.pageSize;
        this.getInfoList();
      },
      showDetail(id) {
        this.isShowDetailModal = true;
        this.$nextTick(function () {
          this.$refs.eleWaybill.showDetail(id);
        })
      },
      goUpdate(id) {
        this.isShowDetailModal = true;
        this.$nextTick(function () {
          this.$refs.eleWaybill.setUpdate(id);
        })
      },
      getCityDate() {
        let appData = require("./../../assets/json/zz.json");
        const getTree = (jsonObj) => {
          function toParse(jsonObj) {
            jsonObj.forEach((item) => {
              item.value = item.label;
              if (item.children && Array.isArray(item.children)) {
                toParse(item.children);
              }
            });
            return jsonObj;
          }

          return toParse(jsonObj);
        };
        this.cityData = getTree(appData);
      },
      async getKeyByCode(code, key) {
        let res = await $api.dict.get("searchDic", {
          parentcode: code
        });
        if (res.status === 1) {
          let arr = [];
          let data = res.data;
          data.map(i => {
            arr.push({
              label: i.dictText,
              value: i.encoded,
            })
          })
          this[key] = arr;
        } else {
          this.$XModal.message(res.message);
        }
      },
    },
  };
</script>

<style>
  .company-dropdown4 {
    width: 400px;
    height: 300px;
    background-color: #fff;
    border: 1px solid #dcdfe6;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
    position: relative;
  }

  .company-dropdown4 .ivu-input-wrapper {
    position: absolute;
    right: 10px;
    top: 8px;
    z-index: 999;
  }

  .company-dropdown4 .ivu-input {
    border-radius: 0;
  }

  .my-form2 .vxe-pulldown {
    width: 100%;
  }

  .my-form2 .sel-link-text {
    border: 1px solid #dcdfe6;
    width: 100%;
    height: 34px;
    line-height: 34px;
    border-radius: 4px;
    text-indent: 8px;
    color: #2d8cf0;
    position: relative;
  }

  .my-form2 .sel-link-text .vxe-icon--arrow-bottom {
    color: #999;
    position: absolute;
    right: 10px;
    top: 8px;
  }
</style>